module.exports = __webpack_public_path__ + "assets/img/icon-1.165bb424.svg";